import { Text, Divider } from '@wework/dieter-ui'
import Row from '../Common/Row'
import measure from '../../assets/icons/measure.png'
import capacity from '../../assets/icons/capacity.png'
import * as _ from 'lodash'
import React from 'react'
import changeCase from 'change-case'
import MetricDisplay from '../Common/MetricDisplay'
import IMTheme from '../../style/IMTheme'
import { getType } from '../../utils/spaces'

interface Props {
  space: any
  BPO: boolean
}

export default function OfficeData({ space, BPO = false }: Props) {
  function getSeatsCapacity() {
    const { inventoryData, reservable } = space

    let seatsAndCapacity = ''
    let seatCount = 0
    if (reservable) {
      if (space.roomType === 'DEDICATED DESK') {
        seatCount = space.metrics?.desks
      } else {
        if (inventoryData?.relationships?.length > 0) {
          seatCount = inventoryData?.relationships[0]?.seat_count
        }
      }
      seatsAndCapacity = seatCount + ` seats / ${reservable.workUnits} capacity`
    }
    return seatsAndCapacity
  }

  const capacityStr = getSeatsCapacity()

  return (
    <>
      {capacityStr && (
        <Row justify="flex-start" style={{ marginBottom: IMTheme.spacing[4] }}>
          <div
            style={{ width: 16, height: 16, marginRight: IMTheme.spacing[4] }}
          >
            <img src={capacity} alt="capacity" />
          </div>
          <Text style={{ fontSize: IMTheme.fontSizes[2] }}>{capacityStr}</Text>
        </Row>
      )}
      <Row justify="flex-start" style={{ marginBottom: IMTheme.spacing[4] }}>
        <div style={{ width: 16, height: 16, marginRight: IMTheme.spacing[4] }}>
          <img src={measure} alt="meassure" />
        </div>
        <MetricDisplay value={space.metrics?.sf} />
      </Row>
    </>
  )
}
